import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Link } from 'react-router-dom';


import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import  { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "bootstrap-icons/font/bootstrap-icons.css";


// Import Swiper styles
import "swiper/css";
const clients = [
    { global: "client-global-01.png", dark: "client-dark-01.png", alt: "Client 01" },
    { global: "client-global-02.png", dark: "client-dark-02.png", alt: "Client 02" },
    { global: "client-global-03.png", dark: "client-dark-03.png", alt: "Client 03" },
    { global: "client-global-04.png", dark: "client-dark-04.png", alt: "Client 04" },
    { global: "client-global-05.png", dark: "client-dark-05.png", alt: "Client 05" },
    { global: "client-global-06.png", dark: "client-dark-06.png", alt: "Client 06" },
    { global: "client-global-07.png", dark: "client-dark-07.png", alt: "Client 07" },
    { global: "client-global-08.png", dark: "client-dark-08.png", alt: "Client 08" },
    { global: "client-global-09.png", dark: "client-dark-09.png", alt: "Client 09" },
  ];
  const slides = [
    {
      bg: "demo-01-slide-1.jpg",
      title: "Reliable Freight Solutions, Delivered — Anywhere, Anytime",
      subtitle: "Instant quotes. Real-time tracking. Seamless booking. Premium logistics, simplified.",
      desc: "Streamlining your logistics with transportation <br /> solutions timely deliveries and exceptional service <br /> worldwide.",
    },
    {
      bg: "demo-01-slide-5.jpg",
      title: "Reliable Freight Solutions, Delivered — Anywhere, Anytime",
      subtitle: "Instant quotes. Real-time tracking. Seamless booking. Premium logistics, simplified.",
      desc: "Streamlining your logistics with transportation <br /> solutions timely deliveries and exceptional service <br /> worldwide.",
    },
    {
      bg: "demo-01-slide-4.jpg",
      title: "Reliable Freight Solutions, Delivered — Anywhere, Anytime",
      subtitle: "Instant quotes. Real-time tracking. Seamless booking. Premium logistics, simplified.",
      desc: "Streamlining your logistics with transportation <br /> solutions timely deliveries and exceptional service <br /> worldwide.",
    },
  ];
const Home = () => {
  
   useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <div className="page-wrapper" id="page">
      <header className="site-header header-style-1">
      <div className="pbmit-slider-area pbmit-slider-one">
        <Swiper
          modules={[Autoplay, Pagination, EffectFade]}
          autoplay={{ delay: 10000, disableOnInteraction: false }}
          loop={true}
          effect="fade"
          pagination={{ clickable: true }}
          slidesPerView={1}
          className="swiper-slider"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="pbmit-slider-item">
                <div
                  className="pbmit-slider-bg"
                  style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner-slider-img/${slide.bg})`,
                  }}
                >
                  {/* Black Overlay */}
                  <div className="pbmit-overlay"></div>
                </div>
                <div className="container">
                  <div className="pbmit-slider-content">
                    <div className="row align-items-end g-0">
                      <div className="col-md-12 col-lg-8">
                        <h5 className="pbmit-sub-title transform-right transform-delay-1 ">
                          <span>{slide.subtitle}</span>
                        </h5>
                        <h2
                          className="pbmit-title transform-left-1 transform-delay-2 "
                          dangerouslySetInnerHTML={{ __html: slide.title }}
                        />
                      </div>
                      <div className="col-md-12 col-lg-4">
                        <div className="pbmit-slider-right-content">
                          <div className="pbmit-desc transform-center transform-delay-3"
                               dangerouslySetInnerHTML={{ __html: slide.desc }}
                          />
                          <div className="pbmit-button transform-bottom transform-delay-4">
  <Link className="pbmit-btn" to="/coming-soon">
    <span className="pbmit-button-content-wrapper">
      <span className="pbmit-button-text">Get a Quick Quote</span>
    </span>
  </Link>
</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </header>
      
   
 <section className="service-two-bg py-5">
  <div className="container">
    {/* Heading */}
    <div className="pbmit-heading-subheading text-center mb-5">
      <h2 className="pbmit-title">Why Choose Us</h2>
      <h4 className="pbmit-subtitle">
        Logistics Solutions to Help Business
      </h4>
    </div>

    {/* Grid with Bootstrap Icons */}
    <div className="row g-4">
      {/* Card 1 */}
      <div className="col-md-6 col-lg-3">
        <div className="card h-100 shadow-sm p-4 text-center">
          <i className="bi bi-box-seam fs-1 text-success mb-3"></i>
          <h5 className="fw-bold">Instant Freight Quotes</h5>
          <p className="mb-0">
            Get accurate estimates based on real-time market rates and shipment details.
          </p>
        </div>
      </div>

      {/* Card 2 */}
      <div className="col-md-6 col-lg-3">
        <div className="card h-100 shadow-sm p-4 text-center">
          <i className="bi bi-truck fs-1 text-primary mb-3"></i>
          <h5 className="fw-bold">Global Carrier Network</h5>
          <p className="mb-0">
            Ship FTL, LTL, intermodal, specialized freight with carriers matched precisely to your needs.
          </p>
        </div>
      </div>

      {/* Card 3 */}
      <div className="col-md-6 col-lg-3">
        <div className="card h-100 shadow-sm p-4 text-center">
          <i className="bi bi-geo-alt fs-1 text-warning mb-3"></i>
          <h5 className="fw-bold">Real-Time Tracking & Updates</h5>
          <p className="mb-0">
            Monitor every move of your shipment via GPS tracking and proactive status alerts.
          </p>
        </div>
      </div>

      {/* Card 4 */}
      <div className="col-md-6 col-lg-3">
        <div className="card h-100 shadow-sm p-4 text-center">
          <i className="bi bi-shield-lock fs-1 text-info mb-3"></i>
          <h5 className="fw-bold">Secure & Transparent Booking</h5>
          <p className="mb-0">
            Trust our encrypted payments and no-hidden-fees policy.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

    
   <section className="section-lg why-trackline-xr">
  <div className="container">
    <div className="pbmit-heading-subheading text-center">
      {/* Center Title */}
      <h2 className="pbmit-title">Why Trackline XR</h2>

      {/* Subtitle with bigger font */}
      <div className="pbmit-heading-subheading text-center mb-5">
        <h2
          className="pbmit-subtitle"
          style={{ fontSize: "2rem", lineHeight: "1.4", fontWeight: "600" }}
        >
          Freight Doesn’t Need More Noise. <br /> It Needs Command.
        </h2>
      </div>
    </div>

    {/* Split Columns */}
    <div className="row">
      {/* Left Column → For Shippers */}
      <div className="col-md-6 d-flex">
        <article className="pbmit-blog-style-1 w-100">
          <div className="post-item h-100 d-flex flex-column">
            <div className="pbminfotech-box-content d-flex flex-column h-100">
              {/* Subheading */}
              <h3 className="pbmit-post-title mb-3">
                Shippers Don’t Need More Status Emails.
              </h3>
              <p className="pbmit-post-desc mb-4">
                Shippers need one reliable source of truth. At Trackline XR,
                we’ve reimagined freight brokerage into a Command Logistics™
                platform—bringing together visibility, dependable capacity,
                compliance, and documentation under one roof.
              </p>

              {/* Differentiators */}
              <ul className="pbmit-differentiators list-unstyled mb-4">
                <li className="mb-2">
                  <i className="bi bi-bullseye me-2"></i>
                  <strong>Predictability, Not Just Visibility</strong> — Clear
                  updates, delivery proof, quick issue resolution.
                </li>
                <li className="mb-2">
                  <i className="bi bi-shield-check me-2"></i>
                  <strong>Compliance by Design</strong> — Insurance & safety
                  checks built into every load.
                </li>
                <li className="mb-2">
                  <i className="bi bi-truck me-2"></i>
                  <strong>Capacity You Can Trust</strong> — Vetted carriers,
                  proven performance, smart matching.
                </li>
                <li className="mb-2">
                  <i className="bi bi-collection me-2"></i>
                  <strong>One Command Center</strong> — Booking, paperwork,
                  oversight—all in one place.
                </li>
              </ul>

              {/* CTA Button */}
              {/* <div className="mt-auto">
                <a href="#" className="btn btn-primary">
                  Get a Demo
                </a>
              </div> */}
            </div>
          </div>
        </article>
      </div>

      {/* Right Column → For Carriers */}
      <div className="col-md-6 d-flex">
        <article className="pbmit-blog-style-1 w-100">
          <div className="post-item h-100 d-flex flex-column">
            <div className="pbminfotech-box-content d-flex flex-column h-100">
              {/* Subheading */}
              <h3 className="pbmit-post-title mb-3">
                Carriers Don’t Need More Hassle.
              </h3>
              <p className="pbmit-post-desc mb-4">
                Carriers need a partner who makes it simple to move freight,
                get paid, and grow. At Trackline XR, we’ve reshaped freight
                brokerage into a Command Logistics™ platform—where trust,
                fairness, and opportunity come together.
              </p>

              {/* Differentiators */}
              <ul className="pbmit-differentiators list-unstyled mb-4">
                <li className="mb-2">
                  <i className="bi bi-cash-stack me-2"></i>
                  <strong>Fair & Fast Pay</strong> — Clear paperwork, quicker
                  settlements, no surprises.
                </li>
                <li className="mb-2">
                  <i className="bi bi-file-earmark-arrow-up me-2"></i>
                  <strong>Compliance Made Simple</strong> — Upload docs once,
                  stay covered on every load.
                </li>
                <li className="mb-2">
                  <i className="bi bi-signpost-split me-2"></i>
                  <strong>Reliable Loads, Real Partnerships</strong> —
                  Consistent freight and transparent lanes.
                </li>
                <li className="mb-2">
                  <i className="bi bi-laptop me-2"></i>
                  <strong>One Command Center</strong> — Book, upload, and
                  track—all without juggling systems.
                </li>
              </ul>

              {/* CTA Button */}
              {/* <div className="mt-auto">
                <a href="#" className="btn btn-outline-primary">
                  Join Our Network
                </a>
              </div> */}
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</section>

<section className="section-xl py-5" style={{ backgroundColor: "#f8f9fa" }}>
  <div className="container">
    {/* Section Heading */}
    <div className="row mb-5">
      <div className="col-12 text-center">
        <h2 className="pbmit-title" style={{ fontWeight: "700", color: "#212529" }}>
          Our Logistics Services
        </h2>
        <p style={{ color: "#6c757d", fontSize: "1.1rem" }}>
          Optimized solutions for all your short and long-haul needs
        </p>
      </div>
    </div>

    {/* First Row - 4 Services */}
    <div className="row g-4 mb-4">
      {/* Over-the-Road */}
      <article className="col-md-6 col-lg-3">
        <Link to="/over-the-road" className="text-decoration-none">
          <div
            className="card h-100 text-center border-0 shadow-sm"
            style={{ borderRadius: "15px", transition: "transform 0.3s", cursor: "pointer" }}
          >
            <div className="card-body">
              <div
                className="mb-3"
                style={{ fontSize: "2.5rem", color: "#0d6efd" }}
              >
                <i className="bi bi-truck-front"></i>
              </div>
              <h5 className="card-title" style={{ fontWeight: "600", color: "#212529" }}>
                Over-the-Road
              </h5>
              <p className="card-text text-muted">
                Reliable, nationwide truckload (FTL & LTL) transportation for any freight.
              </p>
            </div>
          </div>
        </Link>
      </article>

      {/* Intermodal */}
      <article className="col-md-6 col-lg-3">
        <Link to="/intermodal" className="text-decoration-none">
          <div
            className="card h-100 text-center border-0 shadow-sm"
            style={{ borderRadius: "15px", transition: "transform 0.3s", cursor: "pointer" }}
          >
            <div className="card-body">
              <div
                className="mb-3"
                style={{ fontSize: "2.5rem", color: "#198754" }}
              >
                <i className="bi bi-train-front"></i>
              </div>
              <h5 className="card-title" style={{ fontWeight: "600", color: "#212529" }}>
                Intermodal
              </h5>
              <p className="card-text text-muted">
                Cost-effective rail solutions combined with over-the-road transport.
              </p>
            </div>
          </div>
        </Link>
      </article>

      {/* Drayage */}
      <article className="col-md-6 col-lg-3">
        <Link to="/drayage" className="text-decoration-none">
          <div
            className="card h-100 text-center border-0 shadow-sm"
            style={{ borderRadius: "15px", transition: "transform 0.3s", cursor: "pointer" }}
          >
            <div className="card-body">
              <div
                className="mb-3"
                style={{ fontSize: "2.5rem", color: "#fd7e14" }}
              >
                <i className="bi bi-box-seam"></i>
              </div>
              <h5 className="card-title" style={{ fontWeight: "600", color: "#212529" }}>
                Drayage
              </h5>
              <p className="card-text text-muted">
                Seamless port-to-door container transport and shipment handling.
              </p>
            </div>
          </div>
        </Link>
      </article>

      {/* Warehousing */}
      <article className="col-md-6 col-lg-3">
        <Link to="/warehousing" className="text-decoration-none">
          <div
            className="card h-100 text-center border-0 shadow-sm"
            style={{ borderRadius: "15px", transition: "transform 0.3s", cursor: "pointer" }}
          >
            <div className="card-body">
              <div
                className="mb-3"
                style={{ fontSize: "2.5rem", color: "#6f42c1" }}
              >
                <i className="bi bi-house-door"></i>
              </div>
              <h5 className="card-title" style={{ fontWeight: "600", color: "#212529" }}>
                Warehousing
              </h5>
              <p className="card-text text-muted">
                Secure storage and fulfillment services at strategic locations.
              </p>
            </div>
          </div>
        </Link>
      </article>
    </div>

    {/* Second Row - 4 Services */}
    <div className="row g-4">
      {/* Flatbed */}
      <article className="col-md-6 col-lg-3">
        <Link to="/flatbed" className="text-decoration-none">
          <div
            className="card h-100 text-center border-0 shadow-sm"
            style={{ borderRadius: "15px", transition: "transform 0.3s", cursor: "pointer" }}
          >
            <div className="card-body">
              <div
                className="mb-3"
                style={{ fontSize: "2.5rem", color: "#dc3545" }}
              >
                <i className="bi bi-truck-flatbed"></i>
              </div>
              <h5 className="card-title" style={{ fontWeight: "600", color: "#212529" }}>
                Flatbed
              </h5>
              <p className="card-text text-muted">
                Specialized transport for oversized, heavy, and irregular-shaped cargo.
              </p>
            </div>
          </div>
        </Link>
      </article>

      {/* Reefer */}
      <article className="col-md-6 col-lg-3">
        <Link to="/reefer" className="text-decoration-none">
          <div
            className="card h-100 text-center border-0 shadow-sm"
            style={{ borderRadius: "15px", transition: "transform 0.3s", cursor: "pointer" }}
          >
            <div className="card-body">
              <div
                className="mb-3"
                style={{ fontSize: "2.5rem", color: "#20c997" }}
              >
                <i className="bi bi-snow"></i>
              </div>
              <h5 className="card-title" style={{ fontWeight: "600", color: "#212529" }}>
                Reefer
              </h5>
              <p className="card-text text-muted">
                Temperature-controlled transport for perishable and sensitive goods.
              </p>
            </div>
          </div>
        </Link>
      </article>

      {/* LTL */}
      <article className="col-md-6 col-lg-3">
        <Link to="/ltl" className="text-decoration-none">
          <div
            className="card h-100 text-center border-0 shadow-sm"
            style={{ borderRadius: "15px", transition: "transform 0.3s", cursor: "pointer" }}
          >
            <div className="card-body">
              <div
                className="mb-3"
                style={{ fontSize: "2.5rem", color: "#ffc107" }}
              >
                <i className="bi bi-box"></i>
              </div>
              <h5 className="card-title" style={{ fontWeight: "600", color: "#212529" }}>
                LTL
              </h5>
              <p className="card-text text-muted">
                Less-than-truckload solutions for smaller shipments with cost efficiency.
              </p>
            </div>
          </div>
        </Link>
      </article>

      {/* Cross Border Logistics */}
      <article className="col-md-6 col-lg-3">
        <Link to="/cross-border" className="text-decoration-none">
          <div
            className="card h-100 text-center border-0 shadow-sm"
            style={{ borderRadius: "15px", transition: "transform 0.3s", cursor: "pointer" }}
          >
            <div className="card-body">
              <div
                className="mb-3"
                style={{ fontSize: "2.5rem", color: "#0dcaf0" }}
              >
                <i className="bi bi-globe-americas"></i>
              </div>
              <h5 className="card-title" style={{ fontWeight: "600", color: "#212529" }}>
                Cross Border Logistics
              </h5>
              <p className="card-text text-muted">
                Seamless international shipping and customs clearance services.
              </p>
            </div>
          </div>
        </Link>
      </article>
    </div>
  </div>

  {/* Hover Effect CSS */}
  <style jsx>{`
    .card:hover {
      transform: translateY(-10px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    }
    .text-decoration-none:hover {
      text-decoration: none !important;
    }
  `}</style>
</section>




<div class="page-content">

 {/* <section className="client-section-one">
      <div className="container-fluid">
        <Swiper
          modules={[Autoplay]}
          autoplay={false} 
          loop={true}
          spaceBetween={30}
          slidesPerView={6}
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 10 },
            768: { slidesPerView: 4, spaceBetween: 20 },
            1200: { slidesPerView: 6, spaceBetween: 30 },
          }}
          className="swiper-slider"
        >
          {clients.map((client, index) => (
            <SwiperSlide key={index} className="pbmit-client-style-1">
              <div className="pbmit-border-wrapper">
                <div className="pbmit-client-wrapper pbmit-client-with-hover-img">
                  <h4 className="pbmit-hide">{client.alt}</h4>
                  <div className="pbmit-client-hover-img">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/client/${client.global}`}
                      className="img-fluid"
                      alt={client.alt}
                    />
                  </div>
                  <div className="pbmit-featured-img-wrapper">
                    <div className="pbmit-featured-wrapper">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/client/${client.dark}`}
                        className="img-fluid"
                        alt={`${client.alt} Dark`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section> */}





  <section className="service-one-bg pbmit-bg-color-blackish py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-8">
            <div className="pbmit-heading-subheading">
              <h4 className="pbmit-subtitle text-white">How It Works</h4>
              <h2 className="pbmit-title text-white">
                Step by Step <br /> Process
              </h2>
            </div>
          </div>
          <div className="col-md-4 text-end">
            <div className="service-arrow swiper-btn-custom d-inline-flex flex-row-reverse"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid mt-4">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={4}
          navigation={{
            nextEl: ".service-arrow",
            prevEl: ".service-arrow",
          }}
          pagination={{
            clickable: true,
            el: ".swiper-pagination",
          }}
          loop={true}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
          className="pbmit-element-service-style-3"
        >
          {/* Step 1 */}
          <SwiperSlide>
            <div className="card h-100 shadow-sm p-4 text-center bg-dark text-white hover-card">
              <i className="bi bi-file-earmark-text fs-1 text-primary mb-3"></i>
              <h5 className="fw-bold text-primary">01. Quote & Book</h5>
              <p className="mb-0 text-light">
                Submit shipment details → Get instant quote → Customize as needed → Confirm booking.
              </p>
            </div>
          </SwiperSlide>

          {/* Step 2 */}
          <SwiperSlide>
            <div className="card h-100 shadow-sm p-4 text-center bg-dark text-white hover-card">
              <i className="bi bi-truck fs-1 text-success mb-3"></i>
              <h5 className="fw-bold text-primary">02. Carrier Matching</h5>
              <p className="mb-0 text-light">
                Our team selects best-fit carriers with the right equipment and optimized routes.
              </p>
            </div>
          </SwiperSlide>

          {/* Step 3 */}
          <SwiperSlide>
            <div className="card h-100 shadow-sm p-4 text-center bg-dark text-white hover-card">
              <i className="bi bi-geo-alt fs-1 text-warning mb-3"></i>
              <h5 className="fw-bold text-primary">03. Transparent Tracking</h5>
              <p className="mb-0 text-light">
                Stay informed with real-time tracking from the origin to destination.
              </p>
            </div>
          </SwiperSlide>

          {/* Step 4 */}
          <SwiperSlide>
            <div className="card h-100 shadow-sm p-4 text-center bg-dark text-white hover-card">
              <i className="bi bi-headset fs-1 text-info mb-3"></i>
              <h5 className="fw-bold text-primary">04. Delivery & Support</h5>
              <p className="mb-0 text-light">
                Upon delivery, we handle claims, documentation, and compliance support.
              </p>
            </div>
          </SwiperSlide>

          {/* Pagination */}
          <div className="swiper-pagination d-md-none mt-3"></div>
        </Swiper>
      </div>

      {/* Hover Effect */}
      <style jsx>{`
        .hover-card {
          border-radius: 12px;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .hover-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.4);
        }

        /* Optional: Pagination dots style */
        .swiper-pagination-bullet {
          background: #0d6efd;
          opacity: 1;
        }
        .swiper-pagination-bullet-active {
          background: #ffc107;
        }
      `}</style>
    </section>




  <section className="service-two-bg py-5">
  <div className="container">
    {/* Heading */}
    <div className="pbmit-heading-subheading text-center mb-5">
      <h2 className="pbmit-title">Industries We Serve</h2>
      <h4 className="pbmit-subtitle">
        Built for Every Supply Chain Challenge.
      </h4>
    </div>

    {/* First Row - 4 Boxes */}
    <div className="row g-4">
      {/* Retail & eCommerce */}
      <div className="col-md-6 col-lg-3">
        <Link to="/retail" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-bag fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Retail & eCommerce</h5>
            <p className="mb-0">
              Cut chargebacks with timestamped PODs & delivery photos.
            </p>
          </div>
        </Link>
      </div>

      {/* Automotive & Industrial */}
      <div className="col-md-6 col-lg-3">
        <Link to="/automotive" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-truck fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Automotive & Industrial</h5>
            <p className="mb-0">
              JIT reliability to keep plants moving; downtime prevention.
            </p>
          </div>
        </Link>
      </div>

      {/* Food & Beverage */}
      <div className="col-md-6 col-lg-3">
        <Link to="/food-beverage" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-cup-straw fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Food & Beverage</h5>
            <p className="mb-0">
              Temperature compliance, FSMA care, detention control.
            </p>
          </div>
        </Link>
      </div>

      {/* Oil, Gas & Energy */}
      <div className="col-md-6 col-lg-3">
        <Link to="/oil-gas-energy" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-fuel-pump fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Oil, Gas & Energy</h5>
            <p className="mb-0">
              Safety-ready carriers, site access, specialized equipment.
            </p>
          </div>
        </Link>
      </div>
    </div>
    
    {/* Second Row - 4 Boxes */}
    <div className="row g-4 mt-4">
      {/* Healthcare & Pharma */}
      <div className="col-md-6 col-lg-3">
        <Link to="/healthcare-pharma" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-prescription2 fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Healthcare & Pharma</h5>
            <p className="mb-0">
              Secure chain of custody, strict POD handling.
            </p>
          </div>
        </Link>
      </div>

      {/* Manufacturing & Construction */}
      <div className="col-md-6 col-lg-3">
        <Link to="/manufacturing" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-building fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Manufacturing & Construction</h5>
            <p className="mb-0">
              Jobsite coordination, OD/odd-size moves.
            </p>
          </div>
        </Link>
      </div>

      {/* Government & Defense */}
      <div className="col-md-6 col-lg-3">
        <Link to="/government-defense" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-bank fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Government & Defense</h5>
            <p className="mb-0">
              Compliance documentation, bonded & secure flows.
            </p>
          </div>
        </Link>
      </div>

      {/* Produce */}
      <div className="col-md-6 col-lg-3">
        <Link to="/produce" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-apple fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Produce</h5>
            <p className="mb-0">
              Freshness tracking, cold chain integrity, rapid delivery.
            </p>
          </div>
        </Link>
      </div>
    </div>
    
    {/* Third Row - 2 Boxes Centered */}
    <div className="row g-4 mt-4 justify-content-center">
      {/* Renewable Energy */}
      <div className="col-md-6 col-lg-3">
        <Link to="/renewable-energy" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-lightning-charge fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Renewable Energy</h5>
            <p className="mb-0">
              Component transport, site logistics, specialized handling.
            </p>
          </div>
        </Link>
      </div>
      
      {/* Building Materials */}
      <div className="col-md-6 col-lg-3">
        <Link to="/building-materials" className="text-decoration-none">
          <div className="card h-100 shadow-sm p-4 text-center">
            <i className="bi bi-hammer fs-1 text-primary mb-3"></i>
            <h5 className="fw-bold">Building Materials</h5>
            <p className="mb-0">
              Heavy haul expertise, jobsite delivery coordination.
            </p>
          </div>
        </Link>
      </div>
    </div>
  </div>
</section>

<section className="section-xl py-5" style={{ backgroundColor: "#f8f9fa" }}>
  <div className="container">
    {/* Section Heading */}
    <div className="row mb-5">
      <div className="col-12 text-center">
        <h2 className="pbmit-title" style={{ fontWeight: "700", color: "#212529" }}>
          Why Work With Us?
        </h2>
        <p style={{ color: "#6c757d", fontSize: "1.1rem" }}>
          Discover the reasons our clients trust us for their logistics needs
        </p>
      </div>
    </div>

    {/* First Row - 3 Boxes */}
    <div className="row g-4">
      {/* Box 1 */}
      <article className="col-md-6 col-lg-4">
        <div className="card h-100 text-center border-0 shadow-sm" style={{ borderRadius: "15px", transition: "transform 0.3s" }}>
          <div className="card-body">
            <div className="mb-3" style={{ fontSize: "2.5rem", color: "#0d6efd" }}>
              <i className="bi bi-globe2"></i>
            </div>
            <h5 className="card-title" style={{ fontWeight: "600" }}>Global Reach, Local Expertise</h5>
            <p className="card-text text-muted">
              A dynamic carrier network ensuring optimal service across lanes.
            </p>
          </div>
        </div>
      </article>

      {/* Box 2 */}
      <article className="col-md-6 col-lg-4">
        <div className="card h-100 text-center border-0 shadow-sm" style={{ borderRadius: "15px", transition: "transform 0.3s" }}>
          <div className="card-body">
            <div className="mb-3" style={{ fontSize: "2.5rem", color: "#198754" }}>
              <i className="bi bi-cash-stack"></i>
            </div>
            <h5 className="card-title" style={{ fontWeight: "600" }}>Cost-Effective Logistics</h5>
            <p className="card-text text-muted">
              Smart consolidation and network leverage for competitive pricing.
            </p>
          </div>
        </div>
      </article>

      {/* Box 3 */}
      <article className="col-md-6 col-lg-4">
        <div className="card h-100 text-center border-0 shadow-sm" style={{ borderRadius: "15px", transition: "transform 0.3s" }}>
          <div className="card-body">
            <div className="mb-3" style={{ fontSize: "2.5rem", color: "#dc3545" }}>
              <i className="bi bi-shield-lock"></i>
            </div>
            <h5 className="card-title" style={{ fontWeight: "600" }}>Secure & Compliant Systems</h5>
            <p className="card-text text-muted">
              Advanced systems for tracking, billing, documentation, and regulatory adherence.
            </p>
          </div>
        </div>
      </article>
    </div>

    {/* Second Row - 2 Boxes */}
    <div className="row g-4 mt-4 justify-content-center">
      {/* Box 4 */}
      <article className="col-md-6 col-lg-4">
        <div className="card h-100 text-center border-0 shadow-sm" style={{ borderRadius: "15px", transition: "transform 0.3s" }}>
          <div className="card-body">
            <div className="mb-3" style={{ fontSize: "2.5rem", color: "#fd7e14" }}>
              <i className="bi bi-arrows-fullscreen"></i>
            </div>
            <h5 className="card-title" style={{ fontWeight: "600" }}>Flex and Scale</h5>
            <p className="card-text text-muted">
              From ad hoc loads to full-ocean planning: services scale with your growth.
            </p>
          </div>
        </div>
      </article>

      {/* Box 5 */}
      <article className="col-md-6 col-lg-4">
        <div className="card h-100 text-center border-0 shadow-sm" style={{ borderRadius: "15px", transition: "transform 0.3s" }}>
          <div className="card-body">
            <div className="mb-3" style={{ fontSize: "2.5rem", color: "#6f42c1" }}>
              <i className="bi bi-people"></i>
            </div>
            <h5 className="card-title" style={{ fontWeight: "600" }}>Customer Success Focus</h5>
            <p className="card-text text-muted">
              Proactive communication channels and dedicated support at every step.
            </p>
          </div>
        </div>
      </article>
    </div>
  </div>

  {/* Hover Effect CSS */}
  <style jsx>{`
    .card:hover {
      transform: translateY(-10px);
      box-shadow: 0 20px 40px rgba(0,0,0,0.15);
    }
  `}</style>
</section>

 <section className="service-two-bg py-10 bg-gray-50">
      <div className="container">
        {/* Heading */}
        <div
          className="pbmit-heading-subheading text-center mb-12"
          data-aos="fade-down"
        >
          <h2 className="text-3xl font-bold text-gray-800">
            Trailer Types We Serve
          </h2>
          <p className="text-lg text-gray-600 mt-2">
            Here’s a quick overview of the main trailer types we coordinate—and
            what they’re best for:
          </p>
        </div>

        {/* Grid Layout */}
        <div className="row g-4">
          {/* Dry Van */}
          <div className="col-md-6 col-lg-3 " data-aos="zoom-in">
            <div className="card h-100 shadow-sm border-0 text-center p-4">
              <i className="bi bi-box-seam text-primary fs-1 mb-3"></i>
              <h3 className="h5 fw-bold">Dry Van</h3>
              <p className="text-muted">
                Enclosed trailers (48–53 ft) for general, non-perishable cargo.
                Protects shipments from weather and theft.
              </p>
            </div>
          </div>

          {/* Reefer */}
          <div className="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="100">
            <div className="card h-100 shadow-sm border-0 text-center p-4">
              <i className="bi bi-snow text-info fs-1 mb-3"></i>
              <h3 className="h5 fw-bold">Reefer (Refrigerated)</h3>
              <p className="text-muted">
                Temperature-controlled trailers (-20°F to 80°F). Ideal for food,
                pharma, and sensitive goods.
              </p>
            </div>
          </div>

          {/* Flatbed */}
          <div className="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="200">
            <div className="card h-100 shadow-sm border-0 text-center p-4">
              <i className="bi bi-truck-flatbed text-warning fs-1 mb-3"></i>
              <h3 className="h5 fw-bold">Flatbed / Step-Deck / Lowboy</h3>
              <p className="text-muted">
                Open-deck trailers for oversized or odd-shaped cargo. Allows side
                or top loading.
              </p>
            </div>
          </div>

          {/* Drayage */}
          <div className="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="300">
            <div className="card h-100 shadow-sm border-0 text-center p-4">
              <i className="bi bi-truck text-success fs-1 mb-3"></i>
              <h3 className="h5 fw-bold">Drayage / Intermodal Chassis</h3>
              <p className="text-muted">
                Short-haul container transport (port-to-warehouse). Essential for
                international shipments.
              </p>
            </div>
          </div>
        
        </div>
         <div className="row g-4 mt-4 justify-content-center"> 
          <div className="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="400">
            <div className="card h-100 shadow-sm border-0 text-center p-4">
              <i className="bi bi-truck-front text-danger fs-1 mb-3"></i>
              <h3 className="h5 fw-bold">Pup / Double Trailers (LTL)</h3>
              <p className="text-muted">
                Smaller trailers (28-ft pups). Best for partial loads and LTL
                consolidation.
              </p>
            </div>
          </div>

          {/* LCL */}
          <div className="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="500">
            <div className="card h-100 shadow-sm border-0 text-center p-4">
              <i className="bi bi-box text-secondary fs-1 mb-3"></i>
              <h3 className="h5 fw-bold">LCL Containers</h3>
              <p className="text-muted">
                Less-than-container loads. Cost-efficient option for partial freight
                in intermodal shipping.
              </p>
            </div>
          </div>

          {/* Specialized */}
          <div className="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="600">
            <div className="card h-100 shadow-sm border-0 text-center p-4">
              <i className="bi bi-gear-wide-connected text-purple-600 fs-1 mb-3"></i>
              <h3 className="h5 fw-bold">Specialized Trailers</h3>
              <p className="text-muted">
                Custom trailers designed for unique, specialized shipments that don’t
                fit standard categories.
              </p>
            </div>
          </div>
          </div>
      </div>
    </section>

 



<section>
  <div className="container-fluid px-4">
    <div className="row g-0">
      <div className="col-md-12 col-xl-6">
        <div className="contact-one-left-bg"></div>
      </div>
      <div className="col-md-12 col-xl-6">
        <div className="pbmit-bg-color-global contact-one-right-bg">
          <div className="pbmit-heading-subheading">
            <h4 className="pbmit-subtitle">What to expect</h4>
            <h2 className="pbmit-title">Get your free estimate!</h2>
          </div>
          <form
            className="contact-form"
            method="post"
            id="contact-form"
           
          >
            <div className="row">
              <div className="col-md-6">
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Phone Number"
                  name="number"
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email Address"
                  name="email"
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="City Of Depature"
                  name="City"
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Delivery city"
                  name="Delivery"
                  required
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Weight"
                  name="weight"
                  required
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Length"
                  name="length"
                  required
                />
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Width"
                  name="width"
                  required
                />
              </div>
              <div>
                <button className="pbmit-btn pbmit-btn-white submit my-3">
                  <span className="pbmit-button-content-wrapper">
                    <span className="pbmit-button-text">Submit Now</span>
                  </span>
                  <span className="form-btn-loader d-none">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 200 100"
                    >
                      <circle
                        fill="#0036FF"
                        stroke="#0036FF"
                        strokeWidth="15"
                        r="15"
                        cx="40"
                        cy="50"
                      >
                        <animate
                          attributeName="opacity"
                          calcMode="spline"
                          dur="2"
                          values="1;0;1;"
                          keySplines=".5 0 .5 1;.5 0 .5 1"
                          repeatCount="indefinite"
                          begin="-.4"
                        />
                      </circle>
                      <circle
                        fill="#0036FF"
                        stroke="#0036FF"
                        strokeWidth="15"
                        r="15"
                        cx="100"
                        cy="50"
                      >
                        <animate
                          attributeName="opacity"
                          calcMode="spline"
                          dur="2"
                          values="1;0;1;"
                          keySplines=".5 0 .5 1;.5 0 .5 1"
                          repeatCount="indefinite"
                          begin="-.2"
                        />
                      </circle>
                      <circle
                        fill="#0036FF"
                        stroke="#0036FF"
                        strokeWidth="15"
                        r="15"
                        cx="160"
                        cy="50"
                      >
                        <animate
                          attributeName="opacity"
                          calcMode="spline"
                          dur="2"
                          values="1;0;1;"
                          keySplines=".5 0 .5 1;.5 0 .5 1"
                          repeatCount="indefinite"
                          begin="0"
                        />
                      </circle>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
            <div className="col-md-12 col-lg-12 message-status"></div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

{/* <section className="pbmit-element-team-style-2 team-one-bg">
  <div className="container">
    <div className="pbmit-heading-subheading">
      <div className="row">
        <div className="col-md-12 col-xl-3">
          <h4 className="pbmit-subtitle">
            Our experience
          </h4>
        </div>
        <div className="col-md-12 col-xl-9">
          <h2 className="pbmit-title">
            Meet Our Special Support Team Members!
          </h2>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-0 col-xl-3"></div>
      <div className="col-md-12 col-xl-9">
        <div className="pbmit-element-posts-wrapper row">
          <article className="pbmit-team-style-2 col-md-12">
            <div className="pbminfotech-post-item">
              <div className="pbminfotech-team-image-box">
                <div className="pbmit-featured-img-wrapper">
                  <div className="pbmit-featured-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/team/team-01.jpg`} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
              <div className="pbminfotech-box-content">
                <div className="pbminfotech-box-content-inner">
                  <h3 className="pbmit-team-title">
                    <a href="#">Andrea Luies</a>
                  </h3>
                  <div className="pbminfotech-team-position">
                    <div className="pbminfotech-box-team-position">Delivery Manager</div>
                  </div>
                </div>
                <div className="pbminfotech-box-social-links">
                  <ul className="pbmit-social-links pbmit-team-social-links">
                    <li className="pbmit-social-li pbmit-social-facebook">
                      <a href="#" title="Facebook" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-facebook-f"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-twitter">
                      <a href="#" title="Twitter" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-twitter-2"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-linkedin">
                      <a href="#" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-linkedin-in"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-instagram">
                      <a href="#" title="Instagram" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-instagram"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </article>
          <article className="pbmit-team-style-2 col-md-12">
            <div className="pbminfotech-post-item">
              <div className="pbminfotech-team-image-box">
                <div className="pbmit-featured-img-wrapper">
                  <div className="pbmit-featured-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/team/team-02.jpg`} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
              <div className="pbminfotech-box-content">
                <div className="pbminfotech-box-content-inner">
                  <h3 className="pbmit-team-title">
                    <a href="#">Alex Mitchell</a>
                  </h3>
                  <div className="pbminfotech-team-position">
                    <div className="pbminfotech-box-team-position">Technical Lead</div>
                  </div>
                </div>
                <div className="pbminfotech-box-social-links">
                  <ul className="pbmit-social-links pbmit-team-social-links">
                    <li className="pbmit-social-li pbmit-social-facebook">
                      <a href="#" title="Facebook" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-facebook-f"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-twitter">
                      <a href="#" title="Twitter" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-twitter-2"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-linkedin">
                      <a href="#" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-linkedin-in"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-instagram">
                      <a href="#" title="Instagram" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-instagram"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </article>
          <article className="pbmit-team-style-2 col-md-12">
            <div className="pbminfotech-post-item">
              <div className="pbminfotech-team-image-box">
                <div className="pbmit-featured-img-wrapper">
                  <div className="pbmit-featured-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/team/team-03.jpg`} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
              <div className="pbminfotech-box-content">
                <div className="pbminfotech-box-content-inner">
                  <h3 className="pbmit-team-title">
                    <a href="#">John Harris</a>
                  </h3>
                  <div className="pbminfotech-team-position">
                    <div className="pbminfotech-box-team-position">Shipping Head</div>
                  </div>
                </div>
                <div className="pbminfotech-box-social-links">
                  <ul className="pbmit-social-links pbmit-team-social-links">
                    <li className="pbmit-social-li pbmit-social-facebook">
                      <a href="#" title="Facebook" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-facebook-f"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-twitter">
                      <a href="#" title="Twitter" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-twitter-2"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-linkedin">
                      <a href="#" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-linkedin-in"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-instagram">
                      <a href="#" title="Instagram" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-instagram"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </article>
          <article className="pbmit-team-style-2 col-md-12">
            <div className="pbminfotech-post-item">
              <div className="pbminfotech-team-image-box">
                <div className="pbmit-featured-img-wrapper">
                  <div className="pbmit-featured-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/team/team-04.jpg`} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
              <div className="pbminfotech-box-content">
                <div className="pbminfotech-box-content-inner">
                  <h3 className="pbmit-team-title">
                    <a href="#">David Handson</a>
                  </h3>
                  <div className="pbminfotech-team-position">
                    <div className="pbminfotech-box-team-position">Program Manager</div>
                  </div>
                </div>
                <div className="pbminfotech-box-social-links">
                  <ul className="pbmit-social-links pbmit-team-social-links">
                    <li className="pbmit-social-li pbmit-social-facebook">
                      <a href="#" title="Facebook" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-facebook-f"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-twitter">
                      <a href="#" title="Twitter" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-twitter-2"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-linkedin">
                      <a href="#" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-linkedin-in"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-instagram">
                      <a href="#" title="Instagram" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-instagram"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </article>
          <article className="pbmit-team-style-2 col-md-12">
            <div className="pbminfotech-post-item">
              <div className="pbminfotech-team-image-box">
                <div className="pbmit-featured-img-wrapper">
                  <div className="pbmit-featured-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/team/team-05.jpg`} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
              <div className="pbminfotech-box-content">
                <div className="pbminfotech-box-content-inner">
                  <h3 className="pbmit-team-title">
                    <a href="#">Micheal Wagou</a>
                  </h3>
                  <div className="pbminfotech-team-position">
                    <div className="pbminfotech-box-team-position">Data Analyst</div>
                  </div>
                </div>
                <div className="pbminfotech-box-social-links">
                  <ul className="pbmit-social-links pbmit-team-social-links">
                    <li className="pbmit-social-li pbmit-social-facebook">
                      <a href="#" title="Facebook" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-facebook-f"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-twitter">
                      <a href="#" title="Twitter" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-twitter-2"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-linkedin">
                      <a href="#" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-linkedin-in"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-instagram">
                      <a href="#" title="Instagram" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-instagram"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </article>
          <article className="pbmit-team-style-2 col-md-12">
            <div className="pbminfotech-post-item">
              <div className="pbminfotech-team-image-box">
                <div className="pbmit-featured-img-wrapper">
                  <div className="pbmit-featured-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/team/team-06.jpg`} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
              <div className="pbminfotech-box-content">
                <div className="pbminfotech-box-content-inner">
                  <h3 className="pbmit-team-title">
                    <a href="#">Michael Grey</a>
                  </h3>
                  <div className="pbminfotech-team-position">
                    <div className="pbminfotech-box-team-position">Business Analyst</div>
                  </div>
                </div>
                <div className="pbminfotech-box-social-links">
                  <ul className="pbmit-social-links pbmit-team-social-links">
                    <li className="pbmit-social-li pbmit-social-facebook">
                      <a href="#" title="Facebook" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-facebook-f"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-twitter">
                      <a href="#" title="Twitter" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-twitter-2"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-linkedin">
                      <a href="#" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-linkedin-in"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-instagram">
                      <a href="#" title="Instagram" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-instagram"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </article>
          <article className="pbmit-team-style-2 col-md-12">
            <div className="pbminfotech-post-item">
              <div className="pbminfotech-team-image-box">
                <div className="pbmit-featured-img-wrapper">
                  <div className="pbmit-featured-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/team/team-07.jpg`} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
              <div className="pbminfotech-box-content">
                <div className="pbminfotech-box-content-inner">
                  <h3 className="pbmit-team-title">
                    <a href="#">John Martin</a>
                  </h3>
                  <div className="pbminfotech-team-position">
                    <div className="pbminfotech-box-team-position">Finance Coordinator</div>
                  </div>
                </div>
                <div className="pbminfotech-box-social-links">
                  <ul className="pbmit-social-links pbmit-team-social-links">
                    <li className="pbmit-social-li pbmit-social-facebook">
                      <a href="#" title="Facebook" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-facebook-f"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-twitter">
                      <a href="#" title="Twitter" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-twitter-2"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-linkedin">
                      <a href="#" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-linkedin-in"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-instagram">
                      <a href="#" title="Instagram" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-instagram"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </article>
          <article className="pbmit-team-style-2 col-md-12">
            <div className="pbminfotech-post-item">
              <div className="pbminfotech-team-image-box">
                <div className="pbmit-featured-img-wrapper">
                  <div className="pbmit-featured-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/team/team-08.jpg`} className="img-fluid" alt="" />
                  </div>
                </div>
              </div>
              <div className="pbminfotech-box-content">
                <div className="pbminfotech-box-content-inner">
                  <h3 className="pbmit-team-title">
                    <a href="#">Dan Wilkinson</a>
                  </h3>
                  <div className="pbminfotech-team-position">
                    <div className="pbminfotech-box-team-position">Cargo Tracker</div>
                  </div>
                </div>
                <div className="pbminfotech-box-social-links">
                  <ul className="pbmit-social-links pbmit-team-social-links">
                    <li className="pbmit-social-li pbmit-social-facebook">
                      <a href="#" title="Facebook" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-facebook-f"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-twitter">
                      <a href="#" title="Twitter" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-twitter-2"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-linkedin">
                      <a href="#" title="LinkedIn" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-linkedin-in"></i></span>
                      </a>
                    </li>
                    <li className="pbmit-social-li pbmit-social-instagram">
                      <a href="#" title="Instagram" target="_blank" rel="noopener noreferrer">
                        <span><i className="pbmit-base-icon-instagram"></i></span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </article>
          <div className="pbmit-team-btn">
            <a className="pbmit-button-inner" href="#">
              <span className="pbmit-button-icon">
                View All members
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> */}

<section>
  <div className="container">
    <div className="testimonial-one">
      <div className="row g-0">
        {/* Left Icon Section */}
        <div className="col-md-12 col-xl-3">
          <div className="pbmit-spinner-box-style-1">
            <div className="pbmit-ihbox-box">
              <div className="pbmit-ihbox-icon">
                <div className="pbmit-ihbox-icon-wrapper pbmit-icon-type-icon">
                  {/* Icon SVG */}
                  <svg
                    id="Layer_1"
                    enableBackground="new 0 0 100 100"
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m54.75 61.73v-2.37c0-21.98 16.27-39.89 37.52-42.44 2.79-.34 5.23 1.92 5.23 4.73 0 2.43-1.83 4.42-4.24 4.72-7.49.94-14.19 4.34-19.2 9.27-1.78 1.75-.5 4.73 1.99 4.72 12.25 0 21.97 10.1 21.35 22.48-.54 10.83-9.41 19.7-20.24 20.24-12.38.62-22.48-9.1-22.48-21.35z"></path>
                    <path d="m2.5 61.26v-1.9c0-21.98 16.27-39.89 37.52-42.44 2.79-.34 5.23 1.92 5.23 4.73 0 2.43-1.83 4.42-4.24 4.72-7.48.94-14.19 4.34-19.2 9.27-1.78 1.75-.5 4.73 2 4.72 11.87 0 21.37 9.5 21.37 21.37 0 12.09-9.84 21.71-22 21.37-11.64-.33-20.75-10.2-20.75-21.84z"></path>
                  </svg>
                </div>
              </div>
              {/* Circle Text */}
              <svg viewBox="0 0 200 200">
                <defs>
                  <path
                    d="M0, 100a100, 100 0 1, 0 200, 0a100, 100 0 1, 0 -200, 0"
                    id="txt-path"
                  ></path>
                </defs>
                <circle cx="160" cy="100" r="80" fill="none"></circle>
                <text>
                  <textPath startOffset="0" xlinkHref="#txt-path">
                    Testimonial - trusted by clients -
                  </textPath>
                </text>
              </svg>
            </div>
          </div>
        </div>

        {/* Right Testimonials Section */}
        <div className="col-md-12 col-xl-9">
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 10000, disableOnInteraction: false }}
            loop={true}
            pagination={{ clickable: true }}
            slidesPerView={1}
            className="swiper-slider mt-xl-0 mt-5"
          >
            {/* Slide 1 */}
            <SwiperSlide>
              <article className="pbmit-testimonial-style-1">
                <div className="pbminfotech-post-item">
                  <div className="pbmit-box-content-wrap">
                    <div className="pbminfotech-box-star-ratings">
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                    </div>
                    <div className="pbminfotech-box-desc">
                      <blockquote className="pbminfotech-testimonial-text">
                        <p>
                          “Trackline XR has transformed how we manage freight. From port drayage at LA/LB to final-mile delivery, their team provides updates 24/7 and ensures zero surprises. We’ve seen cost savings and smoother operations since partnering.”
                        </p>
                      </blockquote>
                    </div>
                    <div className="pbminfotech-box-author d-flex align-items-center px-4">
                      <div className="pbminfotech-box-img">
                        <div className="pbmit-featured-img-wrapper">
                          <div className="pbmit-featured-wrapper">
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-05.png`}
                              alt="reviewer-01"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="pbmit-auther-content">
                        <h3 className="pbminfotech-box-title">
                          Supply Chain Director
                        </h3>
                        <div className="pbminfotech-testimonial-detail">
                          National Retailer
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </SwiperSlide>

            {/* Slide 2 */}
            <SwiperSlide>
              <article className="pbmit-testimonial-style-1">
                <div className="pbminfotech-post-item">
                  <div className="pbmit-box-content-wrap">
                    <div className="pbminfotech-box-star-ratings">
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                    </div>
                    <div className="pbminfotech-box-desc">
                      <blockquote className="pbminfotech-testimonial-text">
                        <p>
                          “Working with Trackline XR feels like working with a true partner. Their dispatch team is professional, payments are always on time, and their quick-pay program keeps our cash flow healthy. It’s the kind of relationship every carrier hopes for.”
                        </p>
                      </blockquote>
                    </div>
                    <div className="pbminfotech-box-author d-flex align-items-center px-4">
                      <div className="pbminfotech-box-img">
                        <div className="pbmit-featured-img-wrapper">
                          <div className="pbmit-featured-wrapper">
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-07.png`}
                              alt="reviewer-02"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="pbmit-auther-content">
                        <h3 className="pbminfotech-box-title">
                          Owner-Operator
                        </h3>
                        <div className="pbminfotech-testimonial-detail">
                          Midwest Carrier
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </SwiperSlide>

            {/* Slide 3 */}
            <SwiperSlide>
              <article className="pbmit-testimonial-style-1">
                <div className="pbminfotech-post-item">
                  <div className="pbmit-box-content-wrap">
                    <div className="pbminfotech-box-star-ratings">
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                    </div>
                    <div className="pbminfotech-box-desc">
                      <blockquote className="pbminfotech-testimonial-text">
                        <p>
                          “Reliability and compliance are critical for us, and Trackline XR has delivered both without fail. Their vetted carrier network and transparent operations give us complete confidence in every shipment, whether it’s a single load or a high-volume lane.”
                        </p>
                      </blockquote>
                    </div>
                    <div className="pbminfotech-box-author d-flex align-items-center px-4">
                      <div className="pbminfotech-box-img">
                        <div className="pbmit-featured-img-wrapper">
                          <div className="pbmit-featured-wrapper">
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-08.png`}
                              alt="reviewer-03"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="pbmit-auther-content">
                        <h3 className="pbminfotech-box-title">
                          Logistics Manager
                        </h3>
                        <div className="pbminfotech-testimonial-detail">
                          Industrial Manufacturer
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </SwiperSlide>

            {/* Slide 4 */}
            <SwiperSlide>
              <article className="pbmit-testimonial-style-1">
                <div className="pbminfotech-post-item">
                  <div className="pbmit-box-content-wrap">
                    <div className="pbminfotech-box-star-ratings">
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                    </div>
                    <div className="pbminfotech-box-desc">
                      <blockquote className="pbminfotech-testimonial-text">
                        <p>
                          “Navigating U.S. ports and customs used to be complicated. Trackline XR simplified the entire process, from customs clearance to inland transport, with clear communication at every step. They’ve become our go-to partner for U.S. logistics.”
                        </p>
                      </blockquote>
                    </div>
                    <div className="pbminfotech-box-author d-flex align-items-center px-4">
                      <div className="pbminfotech-box-img">
                        <div className="pbmit-featured-img-wrapper">
                          <div className="pbmit-featured-wrapper">
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-09.png`}
                              alt="reviewer-04"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="pbmit-auther-content">
                        <h3 className="pbminfotech-box-title">
                          Export Manager
                        </h3>
                        <div className="pbminfotech-testimonial-detail">
                          Global Trading Company
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </SwiperSlide>

            {/* Slide 5 */}
            <SwiperSlide>
              <article className="pbmit-testimonial-style-1">
                <div className="pbminfotech-post-item">
                  <div className="pbmit-box-content-wrap">
                    <div className="pbminfotech-box-star-ratings">
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                      <i className="pbmit-base-icon-star-1 pbmit-active"></i>
                    </div>
                    <div className="pbminfotech-box-desc">
                      <blockquote className="pbminfotech-testimonial-text">
                        <p>
                          “Trackline XR’s ability to integrate warehousing and trucking seamlessly has eliminated bottlenecks in our operations. Their visibility tools and proactive communication set them apart from traditional brokers.”
                        </p>
                      </blockquote>
                    </div>
                    <div className="pbminfotech-box-author d-flex align-items-center px-4">
                      <div className="pbminfotech-box-img">
                        <div className="pbmit-featured-img-wrapper">
                          <div className="pbmit-featured-wrapper">
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/reviewer/reviewer-10.png`}
                              alt="reviewer-05"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="pbmit-auther-content">
                        <h3 className="pbminfotech-box-title">
                          Operations Head
                        </h3>
                        <div className="pbminfotech-testimonial-detail">
                          3PL Partner
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </SwiperSlide>

          </Swiper>
        </div>
      </div>
    </div>
  </div>
</section>





<section>
      <div className="container-fluid px-4">
        <div className="row g-0">
          {/* Left Video Section */}
          <div className="col-md-8 video-one-left-col">
            <div className="video-one-bg">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/homepage-1/bg/video-bg.jpg`}
                className="img-fluid"
                alt="video background"
              />
              <a
                href="https://www.youtube.com/watch?list=TLGGf0g4v8B4_aowNTAzMjAyNQ&amp;v=L4xeUCqs9I4"
                className="pbmin-lightbox-video video-play-button"
              >
                <i className="fa fa-play"></i>
              </a>
            </div>
          </div>

          {/* Right Content Section */}
          <div className="col-md-4 video-one-right-col">
            <div className="video-one-right-box pbmit-bg-color-global">
              <div className="pbmit-heading">
                <h2 className="fs-4">We know that every decision has an impact</h2>
              </div>

              <div className="pbmit-ihbox-style-6">
                <div className="pbmit-ihbox-headingicon">
                  <div className="pbmit-ihbox-icon">
                    <div className="pbmit-ihbox-icon-wrapper pbmit-icon-type-icon">
                  <i className="bi bi-envelope-fill fs-2" style={{ color: "blue" }}></i>

                    
                    </div>
                  </div>
                  <div className="pbmit-ihbox-contents">
                    <div className="pbmit-heading-desc">Mail Us</div>
                    <h5 className="pbmit-element-title fs-5"> admin@tracklinexr.com</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Right Content */}
        </div>
      </div>
    </section>

     
<section className="accordion-three-bg section-xl">
  <div className="container">
    <div className="row g-0">
      <div className="col-md-0 col-xl-3"></div>
      <div className="col-md-12 col-xl-9">
        <div className="ms-xl-5 ps-xl-4">
          <div className="pbmit-heading-subheading">
            <h2 className="pbmit-title">Frequently Asked Questions</h2>
            <h4>
              At Trackline XR, we know that choosing the right freight partner is
              about more than price — it’s about trust, compliance, and service
              reliability. Below are answers to the most common questions our
              shippers ask us.
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div className="accordion" id="accordionExample1">
      {/* Accordion Item 1 */}
      <div className="accordion-item active" id="headingOne1">
        <h2 className="accordion-header">
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne1"
            aria-expanded="true"
            aria-controls="collapseOne1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">01</span>
              Are you fully licensed and compliant as a freight brokerage?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseOne1"
          className="accordion-collapse collapse show"
          aria-labelledby="headingOne1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            <p>
              Yes. We are registered with the FMCSA (Federal Motor Carrier Safety
              Administration) and operate under an active MC authority. We also
              maintain the required $75,000 surety bond (BMC-84) and broker
              liability insurance, ensuring that your shipments are always handled
              legally, ethically, and securely.
            </p>
          </div>
        </div>
      </div>

      {/* Accordion Item 2 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingTwo1">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo1"
            aria-expanded="false"
            aria-controls="collapseTwo1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">02</span>
              What types of freight services do you provide?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseTwo1"
          className="accordion-collapse collapse"
          aria-labelledby="headingTwo1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            We manage a complete range of transportation services across the
            U.S., including:
            <ul>
              <li>• Full Truckload (FTL) – Dedicated capacity for large shipments.</li>
              <li>• Less-Than-Truckload (LTL) – Cost-effective option for smaller loads.</li>
              <li>• Drayage & Intermodal – Seamless port and rail container movements.</li>
              <li>
                • Specialized Freight – Temperature-controlled, oversized, or
                high-value cargo.
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Accordion Item 3 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingThree1">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseThree1"
            aria-expanded="false"
            aria-controls="collapseThree1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">03</span>
              How do you ensure carriers are reliable and compliant?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseThree1"
          className="accordion-collapse collapse"
          aria-labelledby="headingThree1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            We only partner with vetted carriers who are FMCSA-registered,
            maintain active authority and insurance, and meet strict safety
            standards. Our compliance team continuously monitors carrier
            performance, so your freight is moved by trusted professionals every
            time.
          </div>
        </div>
      </div>

      {/* Accordion Item 4 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingFour1">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseFour1"
            aria-expanded="false"
            aria-controls="collapseFour1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">04</span>
              How do you protect my shipment financially?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseFour1"
          className="accordion-collapse collapse"
          aria-labelledby="headingFour1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            Your freight is safeguarded by multiple layers of protection:
            <ul>
              <li>• Carrier liability insurance (standard for all shipments).</li>
              <li>
                • Our active MC authority, $75,000 surety bond, and broker
                liability insurance.
              </li>
            </ul>
            This means your cargo — and your payments — are always protected.
          </div>
        </div>
      </div>

      {/* Accordion Item 5 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingFive1">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseFive1"
            aria-expanded="false"
            aria-controls="collapseFive1"
          >
            <span className="pbmit-accordion-title">
              <span className="pbmit-number">05</span>
              How are shipping rates determined?
            </span>
            <span className="pbmit-accordion-icon">
              <span className="pbmit-accordion-icon-opened">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
              <span className="pbmit-accordion-icon-closed">
                <i className="pbmit-shipex-icon pbmit-shipex-icon-levels"></i>
              </span>
            </span>
          </button>
        </h2>
        <div
          id="collapseFive1"
          className="accordion-collapse collapse"
          aria-labelledby="headingFive1"
          data-bs-parent="#accordionExample1"
        >
          <div className="accordion-body">
            Rates depend on shipment size and weight, pickup and delivery
            locations, service type (FTL, LTL, intermodal), and current market
            conditions (fuel, capacity). We leverage our carrier network and
            real-time market intelligence to secure the most competitive and
            transparent rates for your business.
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



</div>
      
    </div>
  );
};

export default Home;